import { v4 as uuidv4 } from "uuid";
import CookieStorage from "./CookieStorage";
import httpService from "./http.service";
import EnvironmentNames from "../utils/constants/EnvironmentNames";

const domain =
  httpService.getEnvironmentId() === EnvironmentNames.LOCALHOST
    ? window.location.hostname
    : ".cuvama.com";

const storage = new CookieStorage({
  domain,
  secure: httpService.getEnvironmentId() !== EnvironmentNames.LOCALHOST,
  sameSite:
    httpService.getEnvironmentId() !== EnvironmentNames.LOCALHOST
      ? "none"
      : "strict",
  expires: 1
});

const REDIRECT_TARGET_KEY = "cuvama-login-redirect-target";

const saveState = (stateData) => {
  const state = uuidv4();

  if (stateData) {
    storage.setItem(state, JSON.stringify(stateData));
  }

  return state;
};

const getState = ({ state }) => {
  const stateData = storage.getItem(state);

  if (!stateData) {
    return null;
  }

  try {
    return JSON.parse(stateData);
  } catch {
    return null;
  }
};

const saveRedirectTarget = (target) => {
  if (target) {
    storage.setItem(REDIRECT_TARGET_KEY, JSON.stringify(target));
  } else {
    storage.removeItem(REDIRECT_TARGET_KEY);
  }
};

const getRedirectTarget = () => {
  const target = storage.getItem(REDIRECT_TARGET_KEY);

  if (!target) {
    return null;
  }

  try {
    return JSON.parse(target);
  } catch {
    return null;
  }
};

const clearRedirectTarget = () => {
  storage.removeItem(REDIRECT_TARGET_KEY);
};

export default {
  saveState,
  getState,
  saveRedirectTarget,
  getRedirectTarget,
  clearRedirectTarget
};
